<template lang="pug">
  .edit-cron-task-form.columns
    b-loading(:active="isLoading")

    .column.is-6: .box
      div.columns
        div.column
          b-field(label="Платформа")
            p.mt-3 {{ value.platform_name }}
        div.column
          b-field(label="Сервер")
            p.mt-3 {{ value.server_name }}
        div.column
          b-field(label="Приоритет*", :type="errors && errors.priority ? 'is-danger' : ''", :message="errors.priority")
            b-select(v-model="value.priority")
              option(:value="1")
                | Обычный
              option(:value="2")
                | Высокий
        div.column
          b-field(label="Сложность*", :type="errors && errors.difficulty ? 'is-danger' : ''", :message="errors.difficulty")
            b-select(v-model="value.difficulty")
              option(:value="1")
                | Обычная
              option(:value="2")
                | Высокая

      b-field(label="Команда*", :type="errors && errors.command ? 'is-danger' : ''", :message="errors.command")
        b-input(v-model="value.command", placeholder="Например, medpred:platform-daily")

      br

      b-checkbox(v-model="value.is_test")
        | Тестовая задача &nbsp;
      b-checkbox(v-model="value.is_complex")
        | Составная задача

      br
      br

      b-field(label="Статус*", :type="errors && errors.status ? 'is-danger' : ''", :message="errors.status")
        b-select(v-model="value.status")
          option(v-for="(name, key) in value.statuses" :value="key")
            | {{ name + ' (' + key + ')' }}

      br

      b-field(v-if="value.is_comlex" label="Кол-во итераций")
        | {{ value.index_number }}
      b-field(label="Job Id на платформе")
        | {{ value.platform_job_id }}

      div.columns
        div.column
          b-field(label="Дата создания")
            | {{ value.created_at | dateFormat }}
        div.column
          b-field(label="Создано")
            | {{ value.created_by==='manual' ? 'Вручную' : 'По расписанию' }}
        div.column

      div.columns
        div.column
          b-field(label="Начало работы")
            | {{ value.process_start_at | dateFormat }}
        div.column
          b-field(label="Окончание работы")
            | {{ value.process_end_at | dateFormat }}
        div.column
          b-field(label="Время")
            | {{ value.process_period }}

      div.columns
        div.column
          b-field(label="Дедлайн ожидания")
            | {{ value.wait_deadline_at | dateFormat }}
        div.column
          b-field(label="Дедлайн выполнения")
            | {{ value.process_deadline_at | dateFormat }}
        div.column

      b-field(label="Подробности")
        | {{ value.fullDescription }}
</template>

<script>
import { mapGetters } from 'vuex';
import BSelect from 'buefy/src/components/select/Select';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'edit-cron-task-form',
  components: { BSelect },
  props: {
    value: Object,
    errors: Object,
  },

  data: () => ({
    isLoading: true,
  }),

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    canEdit() {
      return this.user.id === 1 || this.user.id === 4 || this.user.id === 93;
    },
    afterSave() {
      Toast.open({
        type: 'is-success',
        duration: 4000,
        message: 'Данные успешно сохранены',
        queue: false,
      });
    },
  },

  created() {
    this.isLoading = false;
  },
};
</script>

<style scoped>
</style>
